module.exports = __webpack_public_path__ + "static/media/0004.fef00f7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48104/Customs/Customs_black/0004.png
// module id = 1670
// module chunks = 0